import { render, staticRenderFns } from "./zhanghu-edit.vue?vue&type=template&id=ba6a1e38&scoped=true&"
import script from "./zhanghu-edit.vue?vue&type=script&lang=ts&"
export * from "./zhanghu-edit.vue?vue&type=script&lang=ts&"
import style0 from "./zhanghu-edit.vue?vue&type=style&index=0&id=ba6a1e38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6a1e38",
  null
  
)

export default component.exports